<template>
  <div>
    <div class="card-body">

      <div v-if="!isAvalibleStatus" class="alert alert-warning mb-0">
        <i class="fas fa-exclamation-triangle"></i> ไม่สามารถออกผลได้ ({{roundStatus}})
      </div>
      <div v-else-if="!isRoundClosed" class="alert alert-warning mb-0">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        <RoundStatus v-if="round" :data="round" @cssStyle="setStatusStyle" class="badge badge-status font-weight-normal" :class="[cssStatusClass.bg, cssStatusClass.text]" style="font-size: 100%;" />
        ยังไม่ถึงเวลาออกผล
      </div>

      <div v-else>
        <div v-if="isPaid" class="alert alert-success mb-4">
          <i class="far fa-check-circle"></i> จ่ายเงินแล้ว
        </div>

        <div>
          <div class="row mb-2">
            <div class="col-sm-3 d-flex align-items-center">
              <label class="text-danger font-weight-bold mb-0">2 ตัวล่าง</label>
            </div>
            <div class="col-sm-9 form-inline">
              <span v-if="isPaid" class="badge badge-danger mr-1">{{award.two}}</span>
              <b-form-input
                v-else
                placeholder="2 ตัวล่าง"
                v-model="award.two"
                v-on:keydown="keypress"
                maxlength="2"
                :disabled="!(resultStep==='waitResult' || !resultStep) && resultStep !== 'Input-bottom'"
              ></b-form-input>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-3 d-flex align-items-center">
              <label class="text-danger font-weight-bold mb-0">วิ่งล่าง</label>
            </div>
            <div class="col-sm-9 text-primary">
              <span v-for="number in runBottom" class="badge badge-danger mr-1">{{number}}</span>
            </div>
          </div>

          <div v-if="isAvalibleStatus && isRoundClosed && !isPaid" class="row justify-content-end mt-2">
            <div class="col-sm-9 text-right">
              <b-button
                variant="danger"
                size="sm"
                @click="saveResults('bottom')"
                :disabled="!(resultStep==='waitResult' || !resultStep) && resultStep !== 'Input-bottom'"
              ><i class="far fa-save"></i> บันทึกผลเลขล่าง</b-button>
            </div>
          </div>
        </div>

        <hr>

        <div>
          <div class="row mb-2">
            <div class="col-sm-3 d-flex align-items-center">
              <label class="text-success font-weight-bold mb-0">3 ตัวบน</label>
            </div>
            <div class="col-sm-9 form-inline">
              <span v-if="isPaid" class="badge badge-success mr-1">{{award.three}}</span>
              <b-form-input
                v-else
                placeholder="3 ตัวบน"
                v-model="award.three"
                v-on:keydown="keypress"
                maxlength="3"
                :disabled="resultStep!=='LoseItems-bottom' && resultStep!=='Input-top'"
              >
              </b-form-input>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-sm-3 d-flex align-items-center">
              <label class="text-success font-weight-bold mb-0">3 ตัวโต๊ด</label>
            </div>
            <div class="col-sm-9 text-primary">
              <span v-for="number in threeNumberTode" class="badge badge-success mr-1">{{number}}</span>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-sm-3 d-flex align-items-center">
              <label class="text-success font-weight-bold mb-0">2 ตัวบน</label>
            </div>
            <div class="col-sm-9 text-primary">
              <span v-for="number in twoNumberTop" class="badge badge-success mr-1">{{number}}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-3 d-flex align-items-center">
              <label class="text-success font-weight-bold mb-0">วิ่งบน</label>
            </div>
            <div class="col-sm-9 text-primary">
              <span v-for="number in runTop" class="badge badge-success mr-1">{{number}}</span>
            </div>
          </div>

          <div v-if="isAvalibleStatus && isRoundClosed && !isPaid" class="row justify-content-end mt-2">
            <div class="col-sm-9 text-right">
              <b-button
                variant="success"
                size="sm"
                @click="saveResults('top')"
                :disabled="resultStep!=='LoseItems-bottom' && resultStep!=='Input-top'"
              ><i class="far fa-save"></i> บันทึกผลเลขบน</b-button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-if="isAvalibleStatus && resultStep" class="card-footer p-3">
      <div>
        <b-button
          :variant="resultStep==='Input-bottom'?'info':'outline-info'"
          :disabled="resultStep!='Input-bottom'"
          size="sm"
          @click="ProcessingTickets"
        >เริ่มคำนวนผล</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='ProcessingTickets'?'info':'outline-info'"
          :disabled="resultStep!='ProcessingTickets'"
          size="sm"
          @click="ProcessingItems('bottom')"
        >คำนวนผล 2 ตัวล่าง</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='ProcessingItems-bottom'?'info':'outline-info'"
          :disabled="resultStep!='ProcessingItems-bottom'"
          size="sm"
          @click="WonItems('twoNumberBottom')"
        >ถูกรางวัล 2 ตัวล่าง</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='twoNumberBottom'?'info':'outline-info'"
          :disabled="resultStep!='twoNumberBottom'"
          size="sm"
          @click="WonItems('runBottom')"
        >ถูกรางวัลวิ่งล่าง</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='runBottom'?'info':'outline-info'"
          :disabled="resultStep!='runBottom'"
          size="sm"
          @click="LoseItems('bottom')"
        >ไม่ถูกรางวัลล่าง</b-button>
      </div>

      <div class="mt-3">
        <b-button
          :variant="resultStep==='Input-top'?'info':'outline-info'"
          :disabled="resultStep!='Input-top'"
          size="sm"
          @click="ProcessingItems('top')"
        >คำนวนผล 3 ตัวบน</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='ProcessingItems-top'?'info':'outline-info'"
          :disabled="resultStep!='ProcessingItems-top'"
          size="sm"
          @click="WonItems('threeNumberTop')"
        >ถูกรางวัล 3 ตัวบน</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='threeNumberTop'?'info':'outline-info'"
          :disabled="resultStep!='threeNumberTop'"
          size="sm"
          @click="WonItems('threeNumberTode')"
        >ถูกรางวัล 3 ตัวโต๊ด</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='threeNumberTode'?'info':'outline-info'"
          :disabled="resultStep!='threeNumberTode'"
          size="sm"
          @click="WonItems('twoNumberTop')"
        >ถูกรางวัล 2 ตัวบน</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='twoNumberTop'?'info':'outline-info'"
          :disabled="resultStep!='twoNumberTop'"
          size="sm"
          @click="WonItems('runTop')"
        >ถูกรางวัลวิ่งบน</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='runTop'?'info':'outline-info'"
          :disabled="resultStep!='runTop'"
          size="sm"
          @click="LoseItems('top')"
        >ไม่ถูกรางวัลบน</b-button>
      </div>

      <div class="mt-3">
        <b-button
          :variant="resultStep==='LoseItems-top'?'info':'outline-info'"
          :disabled="resultStep!='LoseItems-top'"
          size="sm"
          @click="WonTickets()"
        >โพยถูกรางวัล</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='WonTickets'?'info':'outline-info'"
          :disabled="resultStep!='WonTickets'"
          size="sm"
          @click="LoseTickets()"
        >โพยไม่ถูกรางวัล</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='LoseTickets'?'info':'outline-info'"
          :disabled="resultStep!='LoseTickets'"
          size="sm"
          @click="payWonMembers()"
        >จ่ายเงิน Member</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='payWonMember'?'info':'outline-info'"
          :disabled="resultStep!='payWonMember'"
          size="sm"
          @click="findAgents()"
        >สรุปยอดแพ้ชนะ Agent</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='findAgent'?'info':'outline-info'"
          :disabled="resultStep!='findAgent'"
          size="sm"
          @click="payAgents()"
        >ปรับยอด Agent</b-button>
      </div>

      <div class="mt-3">
        <b-button
          :variant="resultStep==='payAgent'?'info':'outline-info'"
          :disabled="resultStep!='payAgent'"
          size="sm"
          @click="closeTickets()"
        >จบการออกผล</b-button>

        <span class="text-secondary"> > </span>
        <b-button
          :variant="resultStep==='closeTicket'?'info':'outline-info'"
          :disabled="resultStep!='closeTicket'"
          size="sm"
          @click="closeRound()"
        >ปิดงวดหวย</b-button>

      </div>
    </div>

    <div v-if="isAvalibleStatus && resultStep" class="card-footer p-3">

      <div>
        <button
          class="btn btn-danger btn-sm"
          @click="changeResult('cancelResult', 'ยกเลิกผล/แก้ไขผลใหม่')"
          :disabled="resultStep!=='Completed'"
          :class="resultStep==='Completed'?'btn-danger':'btn-outline-danger'"
        >
          <i class="fas fa-undo-alt"></i> แก้ไขผล/คำนวนใหม่
        </button>

        <span class="text-secondary"> > </span>
        <button
          class="btn btn-danger btn-sm"
          @click="changeResult('rollbackCredit', 'ดึงเครดิตกลับจากสมาชิก')"
          :disabled="resultStep!=='cancelResult'"
          :class="resultStep==='cancelResult'?'btn-danger':'btn-outline-danger'"
        >
          ดึงเครดิตกลับ
        </button>

        <span class="text-secondary"> > </span>
        <button
          class="btn btn-danger btn-sm"
          @click="changeResultTicket('ปรับสถานะโพย')"
          :disabled="resultStep!=='rollbackCredit'"
          :class="resultStep==='rollbackCredit'?'btn-danger':'btn-outline-danger'"
        >
          รีเซ็ตโพย
        </button>

        <span class="text-secondary"> > </span>
        <button
          class="btn btn-danger btn-sm"
          @click="changeResultItem('รีเซ็ตรายการแทง')"
          :disabled="resultStep!=='resetTicket'"
          :class="resultStep==='resetTicket'?'btn-danger':'btn-outline-danger'"
        >
          รีเซ็ตรายการแทง
        </button>

        <span class="text-secondary"> > </span>
        <button
          class="btn btn-danger btn-sm"
          @click="changeResult('resetRound', 'ปรับสถานะงวดหวย')"
          :disabled="resultStep!=='resetItem'"
          :class="resultStep==='resetItem'?'btn-danger':'btn-outline-danger'"
        >
          รีเซ็ตงวดหวย
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { marketOpenBets } from "@/configs/market.config"
import LottoService from '@/services/lottoService'
import moment from '@/helpers/moment'
import Swal from 'sweetalert2'
import RoundStatus from './RoundStatus'
import cryptoRandomString from 'crypto-random-string'
import _ from 'lodash'

export default {
  name: 'ResultSingle2',
  props: ['round'],
  components: {
    RoundStatus
  },
  data() {
    return {
      cssStatusClass: {
        bg: null,
        text: null,
        link: null,
        btn: null
      },
      award: {
        three: this.round.results.threeNumberTop.join(''),
        two: this.round.results.twoNumberBottom.join('')
      },
      uniqueCode: cryptoRandomString({length: 12, type: 'alphanumeric'})
    }
  },
  computed: {
    marketOpenBets() {
      return marketOpenBets
    },
    roundId() {
      return this.$store.state.globalMarket.round.roundId
    },
    roundStatus() {
      return this.round?.status
    },
    isAvalibleStatus() {
      if(!this.round)
        return false

      return ['Open', 'Close', 'Complete', 'Paid'].includes(this.round.status)
    },
    isRoundClosed() {
      if(!this.round)
        return false

      if(moment().isBefore(this.round.roundDate.close))
        return false

      return true
    },
    isPaid() {
      return this.round?.status === 'Paid'
    },
    awardThree() {
      if(!this.award.three)
        return null

      const awards = this.award.three.slice('')
      if(awards.length !== 3)
        return null

      return awards
    },
    awardTwo() {
      if(!this.award.two)
        return null

      const awards = this.award.two.slice('')
      if(awards.length !== 2)
        return null

      return awards
    },
    threeNumberTop() {
      if(!this.awardThree)
        return []

      return [this.awardThree]
    },
    threeNumberTode() {
      if(!this.awardThree)
        return []

      const awards = [
        `${this.awardThree[0]}${this.awardThree[1]}${this.awardThree[2]}`,
        `${this.awardThree[0]}${this.awardThree[2]}${this.awardThree[1]}`,
        `${this.awardThree[1]}${this.awardThree[0]}${this.awardThree[2]}`,
        `${this.awardThree[1]}${this.awardThree[2]}${this.awardThree[0]}`,
        `${this.awardThree[2]}${this.awardThree[1]}${this.awardThree[0]}`,
        `${this.awardThree[2]}${this.awardThree[0]}${this.awardThree[1]}`,
      ]
      return _.uniqBy(awards)
    },
    twoNumberTop() {
      if(!this.awardThree)
        return []

      return [`${this.awardThree[1]}${this.awardThree[2]}`]
    },
    runTop() {
      if(!this.awardThree)
        return []

      const awards = [`${this.awardThree[0]}`, `${this.awardThree[1]}`, `${this.awardThree[2]}`]
      return _.uniqBy(awards)
    },
    twoNumberBottom() {
      if(!this.awardTwo)
        return []

      return [this.awardTwo]
    },
    runBottom() {
      if(!this.awardTwo)
        return []

      const awards = [`${this.awardTwo[0]}`, `${this.awardTwo[1]}`]
      return _.uniqBy(awards)
    },
    resultStep() {
      return this.round?.resultStep
    }
  },
  watch: {
    round() {
      if(this.round) {
        this.award = {
          three: this.round.results.threeNumberTop.join(''),
          two: this.round.results.twoNumberBottom.join('')
        }
      }
    }
  },
  methods: {
    setStatusStyle(css) {
      this.cssStatusClass = {
        ...this.cssStatusClass,
        ...css
      }
    },
    keypress(event) {
      if(!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace'].includes(event.key)) {
        event.preventDefault()
      }
    },
    saveResults(pos) {

      if(pos === 'bottom' && !this.awardTwo)
        return Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'กรุณากรอกผล'
        })

      if(pos === 'top' && !this.awardThree)
        return Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'กรุณากรอกผล'
        })

      const results = {
        threeNumberTop: this.threeNumberTop,
        threeNumberTode: this.threeNumberTode,
        twoNumberTop: this.twoNumberTop,
        twoNumberBottom: this.twoNumberBottom,
        runTop: this.runTop,
        runBottom: this.runBottom
      }

      Swal.fire({
        title: 'ยืนยัน!',
        text: "กรุณาตรวจสอบผลให้ถูกต้องก่อนกดยืนยัน",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.saveResults(this.round._id, pos, results).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ไม่สำเร็จ!',
              'กรุณาลองใหม่อีกครั้ง', //(error.message||'กรุณาลองใหม่อีกครั้ง'),
              'error'
            )
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'บันทึกผลหวยสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    ProcessingTickets() {
      Swal.fire({
        title: 'อัพเดตสถานะโพย?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.updateProcessingTickets(this.round._id).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'บันทึกผลหวยไม่สำเร็จ', //(error.message||'บันทึกผลหวยไม่สำเร็จ'),
              'error'
            )
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'บันทึกผลหวยสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    ProcessingItems(betType) {
      Swal.fire({
        title: 'อัพเดตสถานะเลข?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.updateProcessingItems(this.round._id, betType).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'บันทึกผลหวยไม่สำเร็จ', //(error.message||'บันทึกผลหวยไม่สำเร็จ'),
              'error'
            )
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'บันทึกผลหวยสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    WonItems(betType) {
      Swal.fire({
        title: 'อัพเดตเลขถูกรางวัล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.updateWonItems(this.round._id, betType).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'บันทึกผลหวยไม่สำเร็จ', //(error.message||'บันทึกผลหวยไม่สำเร็จ'),
              'error'
            )
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'บันทึกผลหวยสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    LoseItems(betType) {
      Swal.fire({
        title: 'อัพเดตไม่ถูกรางวัล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.updateLoseItems(this.round._id, betType).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'บันทึกผลหวยไม่สำเร็จ', //(error.message||'บันทึกผลหวยไม่สำเร็จ'),
              'error'
            )
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'บันทึกผลหวยสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    WonTickets() {
      Swal.fire({
        title: 'อัพเดตโพยถูกรางวัล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.updateWonTickets(this.round._id).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'บันทึกผลหวยไม่สำเร็จ', //(error.message||'บันทึกผลหวยไม่สำเร็จ'),
              'error'
            )
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'บันทึกผลหวยสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    LoseTickets() {
      Swal.fire({
        title: 'อัพเดตโพยไม่ถูกรางวัล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.updateLoseTickets(this.round._id).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'บันทึกโพยไม่สำเร็จ', //(error.message||'บันทึกโพยไม่สำเร็จ'),
              'error'
            )
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'บันทึกโพยเสร็จเรียบร้อย',
            'success'
          )
          .then(()=>{
            // this.$router.push({name: 'PayWonTickets'})
            this.$emit('reload')
          })
        }
      })
    },
    payWonMembers() {
      Swal.fire({
        title: 'ยืนยันจ่ายเงิน!',
        text: "ยอดจะถูกโอนเข้าบัญชีสมาชิก",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return LottoService.payWonMembers(this.round._id, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'กรุณาลองใหม่อีกครั้ง', //(error.message||'กรุณาลองใหม่อีกครั้ง'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        }
      }).then((result) => {
        console.log(result)
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'จ่ายเงินสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    findAgents() {
      Swal.fire({
        title: 'สรุปยอดแพ้ชนะของเอเย่นต์!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return LottoService.findAgentWinLose(this.round._id, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'กรุณาลองใหม่อีกครั้ง', //(error.message||'กรุณาลองใหม่อีกครั้ง'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        }
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'คำนวนยอดสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    payAgents() {
      Swal.fire({
        title: 'ปรับยอด!',
        text: "ปรับยอดแพ้ชนะบัญชีเอเย่นต์",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return LottoService.payAgents(this.round._id, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'กรุณาลองใหม่อีกครั้ง', //(error.message||'กรุณาลองใหม่อีกครั้ง'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        }
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'จ่ายเงินสำเร็จ',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    closeTickets() {
      Swal.fire({
        title: 'จบการออกผล!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return LottoService.closeTickets(this.round._id, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'กรุณาลองใหม่อีกครั้ง', //(error.message||'กรุณาลองใหม่อีกครั้ง'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        }
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'เสร็จเรียบร้อย',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    closeRound() {
      Swal.fire({
        title: 'ปิดงวดหวย!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return LottoService.closeRound(this.round._id, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'กรุณาลองใหม่อีกครั้ง', //(error.message||'กรุณาลองใหม่อีกครั้ง'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        }
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            'ปิดงวดเสร็จเรียบร้อย',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    changeResult(step, text) {
      Swal.fire({
        title: 'ดำเนินการต่อ!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return LottoService.changeResult(this.roundId, step, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'ยกเลิกจ่ายเงินไม่สำเร็จ', //(error.message||'ยกเลิกจ่ายเงินไม่สำเร็จ'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            '',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    changeResultTicket(text) {
      Swal.fire({
        title: 'ดำเนินการต่อ!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return LottoService.changeResultTicket(this.roundId, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'ยกเลิกจ่ายเงินไม่สำเร็จ', //(error.message||'ยกเลิกจ่ายเงินไม่สำเร็จ'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            '',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    },
    changeResultItem(text) {
      Swal.fire({
        title: 'ดำเนินการต่อ!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return LottoService.changeResultItem(this.round._id, this.uniqueCode).then((response)=>{
            if(response.success) {
              return response.data
            }else{
              throw new Error(response?.message || JSON.stringify(response?.data))
            }
          })
          .catch((error)=>{
            Swal.fire(
              'ผิดพลาด!',
              'กรุณาลองใหม่อีกครั้ง', //(error.message||'กรุณาลองใหม่อีกครั้ง'),
              'error'
            )
          })
          .finally(()=>{
            this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
          })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'สำเร็จ!',
            '',
            'success'
          )
          .then(()=>{
            this.$emit('reload')
          })
        }
      })
    }
  },
  mounted() {
    this.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
  }
}
</script>
<style lang="scss" scoped>
.badge {
  font-size: 100%;
  font-weight: normal;
  letter-spacing: 1px;
}
</style>
